// user is an AmplifyUser, but I can't find the import for it
export default function getUsername(user: any) {
  if (!user) return ''
  const { username } = user

  const startIdx = username.indexOf('_') + 1
  const endIdx = username.indexOf('@')
  return username.substring(startIdx, endIdx)
}